import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/entMaterial/pageList',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/entMaterial',
method: 'post',
data: obj
})
}
//获取权限材料及已经提交材料
export function getList(obj) {
    return request({
        url: '/api/admin/entMaterial/list',
        method: 'post'
    })
}//获取权限材料及已经提交材料
export function materialList(obj) {
    return request({
        url: '/api/admin/entMaterial/materialList',
        method: 'post',
        data: obj
    })
}
//签署合同
export function signContract(obj) {
    return request({
        url: '/api/admin/entMaterial/sign',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
return request({
url: '/api/admin/entMaterial/' + id,
method: 'get'
})
}

export function contractPage(query) {
return request({
url: '/api/admin/entMaterial/contractPage',
method: 'get',
params:query
})
}

export function delObj(id) {
return request({
url: '/api/admin/entMaterial/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/entMaterial/' + id,
method: 'put',
data: obj
})
}
